module.exports = __webpack_public_path__ + "img/ios.84dd72ae.png";